import AaronAmano from '@/data/2025/assets/images/team/aaron_amano-x96.webp'
import AliElSharif from '@/data/2025/assets/images/team/ali_elsharif.webp'
import DaveKoziol from '@/data/2025/assets/images/team/dav_koziol.webp'
import GregMiller from '@/data/2025/assets/images/team/greg_miller-x96.webp'
import HernandoMalabet from '@/data/2025/assets/images/team/hernando_malabet.webp'
import HodaSolati from '@/data/2025/assets/images/team/hoda_solati.webp'
import HudaHussaini from '@/data/2025/assets/images/team/huda_hussaini.webp'
import JennaRitten from '@/data/2025/assets/images/team/jenna_ritten.webp'
import JingranWang from '@/data/2025/assets/images/team/Jingran_Wang-x96.webp'
import JustinBeaudry from '@/data/2025/assets/images/team/justin_beaudry-x96.webp'
import KayleeBusenbark from '@/data/2025/assets/images/team/kaylee_busenbark-x96.webp'
import MaridyMazaira from '@/data/2025/assets/images/team/maridy_mazaira.webp'
import NisaSolano from '@/data/2025/assets/images/team/nisa_solano.webp'
import RaquelEstrada from '@/data/2025/assets/images/team/raquel_estrada.webp'
import Rehanashri from '@/data/2025/assets/images/team/rehanashri-x96.webp'
import RishirajSarkar from '@/data/2025/assets/images/team/rishiraj_sarkar.webp'
import ShimaSolati from '@/data/2025/assets/images/team/shima_solati.webp'
import ShugmiShumunov from '@/data/2025/assets/images/team/shugmi_shumunov-x96.webp'
import SohamMhatre from '@/data/2025/assets/images/team/soham_mhatre.webp'
import SohanKetireddy from '@/data/2025/assets/images/team/sohan_ketireddy-x96.webp'
import SumiaSaleh from '@/data/2025/assets/images/team/Sumia_Saleh-x96.webp'

export const teamData = [
  {
    id: 1,
    name: 'Dave Koziol',
    twitter: 'davekoziol',
    linkedin: 'https://www.linkedin.com/in/davekoziol/',
    github: '',
    devfest: 'organizer',
    star: true,
    university: '',
    organization: 'Little Caesars',
    role: 'GDG Organizer',
    avatar: DaveKoziol,
  },
  {
    id: 2,
    name: 'Jenna Ritten',
    twitter: 'jritten',
    linkedin: 'https://www.linkedin.com/in/jritten/',
    github: 'https://github.com/jritten',
    devfest: 'organizer',
    star: true,
    university: '',
    organization: 'IBM',
    role: 'GDG Organizer + Women Techmakers',
    avatar: JennaRitten,
  },
  {
    id: 3,
    name: 'Huda Hussaini',
    twitter: '',
    linkedin: 'https://www.linkedin.com/in/huda-hussaini/',
    github: '',
    devfest: 'organizer',
    star: false,
    university: '',
    bio: `Have done a few cool AI project like Integrating AI and cybersecurity testing for automotive vehicles, Creating a Gen AI agent for your car and automating contract processing with IDP!`,
    organization: 'Ally Financial + Women Techmakers',
    role: 'GenAI Technical Product Owner',
    avatar: HudaHussaini,
  },
  {
    id: 4,
    name: 'Sumia Saleh',
    twitter: '',
    linkedin: 'https://www.linkedin.com/in/sumia-saleh-163741263/',
    github: 'https://github.com/Sumias',
    devfest: 'organizer',
    star: false,
    university: 'University Of Michigan Dearborn',
    bio: ``,
    organization: '',
    role: 'GDGC Lead',
    avatar: SumiaSaleh,
  },
  {
    id: 5,
    name: 'Greg Miller',
    linkedin: 'https://www.linkedin.com/in/gregraymiller/',
    github: 'https://github.com/shrinkray',
    devfest: 'devteam',
    star: false,
    university: '',
    bio: `
	  Hello, I am the founder of Shrinkray Interactive, a web development studio in Toledo, Ohio, leaning-in on accessible, high-performance, and user-friendly web experiences. As a founding member of GDG Toledo, I connect developers and designers through events and hackathons. Collaborating with the devteam, I oversee UX engineering and redesign for the Michigan DevFest website—creating a fast, inclusive experience for speakers, partners, and attendees. If you are seeking a friendly and talented developer for your project, let's connect.
	`,
    organization: 'Shrinkray Interactive + GDG Toledo + Toledo Codes',
    role: 'Senior UX Engineer + Frontend',
    avatar: GregMiller,
  },
  {
    id: 6,
    name: 'Aaron Amano',
    twitter: '',
    linkedin: 'https://www.linkedin.com/in/aaronamano/',
    github: 'https://github.com/aaronamano',
    devfest: 'devteam',
    star: false,
    university: 'University Of Michigan Dearborn',
    bio: ``,
    organization: '',
    role: 'CS Student',
    avatar: AaronAmano,
  },
  {
    id: 7,
    name: 'Shugmi Shumunov',
    twitter: '',
    linkedin: 'https://www.linkedin.com/in/shugmishumunov/',
    github: 'https://github.com/ShugKnight24',
    devfest: 'devteam',
    star: false,
    university: '',
    bio: `
      Shugmi Shumunov is a software developer who believes code is the ultimate storytelling medium. With a primary focus on the JavaScript ecosystem within e-commerce, working across the stack in various industries. Always seeking beautiful, elegant, and performant solutions while collaborating with talented, curious, and passionate engineers and tech enthusiasts.

      When the terminal is closed and his hands are off the keyboard, you'll find him lifting weights, adventuring outdoors, exploring new places, or immersed in the worlds of manga or a good book
    `,
    organization: 'Shumunov Solutions',
    role: 'Developer',
    avatar: ShugmiShumunov,
  },
  {
    id: 8,
    name: 'Justin Beaudry',
    twitter: '',
    linkedin: 'https://www.linkedin.com/in/justinbeaudry/',
    github: 'https://github.com/justinbeaudry',
    devfest: 'devteam',
    star: false,
    university: '',
    bio: ``,
    organization: 'Actual Reality Technologies + Toledo Codes + GDG Toledo',
    role: 'Director of Engineering',
    avatar: JustinBeaudry,
  },
  {
    id: 9,
    name: 'Rishiraj Sarkar',
    twitter: '',
    linkedin: null,
    github: null,
    devfest: 'marketing',
    star: false,
    university: 'University of Michigan - Dearborn',
    bio: `Cybersecurity graduate student working with AI privacy and network security`,
    organization: '',
    role: 'Student + GDGC Dearborn',
    avatar: RishirajSarkar,
  },
  {
    id: 10,
    name: 'Soham Mhatre',
    twitter: '',
    linkedin: null,
    github: 'https://github.com/soham02',
    devfest: 'devteam',
    star: false,
    university: '',
    bio: `Soham Mhatre is a developer focused on building practical, human-centered software. He works across the MERN stack with a strong focus on cloud and AI workflows. Recent projects include an image labeling system using AWS Recognition and a financial planning/learning platform with real-time persona generation. Soham enjoys translating complex, real-world requirements into simple, shippable features and cares deeply about clean APIs, accessible UIs, and measurable outcomes. Having recently graduated from Harrisburg University with a Master's in Software Engineering, he's now pursuing full-time opportunities where he can contribute end-to-end from backend services and databases to polished frontends that people love to use.  
`,
    organization: 'Mhatre Solutions',
    role: 'Developer',
    avatar: SohamMhatre,
  },
  {
    id: 11,
    name: 'Shima Solati',
    twitter: '',
    linkedin: 'https://www.linkedin.com/in/shima-solati/',
    github: '',
    devfest: 'organizer',
    star: false,
    university: '',
    bio: `Shima Solati is an award-winning UX/UI designer and researcher at BraunAbility, leading efforts to advance mobility and accessibility through innovative, user-centered design. With a Master’s in User Experience Design from the College for Creative Studies and dual degrees in fashion and textiles, Shima brings a rare multidisciplinary perspective to solving complex challenges. Her expertise spans immersive and assistive technologies, VR, AR, robotics, and her portfolio includes impactful work for KUKA Robotics, the Augmented Reality Center, General Motors, and Ford. Passionate about inclusive design and emerging technologies, Shima is dedicated to creating intuitive, innovative solutions that empower all users.`,
    organization: 'BraunAbility',
    role: 'UX/UI Designer & Researcher',
    avatar: ShimaSolati,
  },
  {
    id: 12,
    name: 'Hoda Solati',
    twitter: '',
    linkedin: 'https://www.linkedin.com/in/hoda-solati/',
    github: '',
    devfest: 'marketing',
    star: false,
    university: '',
    bio: `Hoda Solati is an award-winning UX designer working at BraunAbility blending creativity, technology, and innovation to craft inclusive, user-centered experiences. With advanced degrees in UX Design and Animation, she explores cutting-edge technologies such as VR, AR, and robotics to solve complex design challenges. Recognized at global events including DDX’25 NYC and IEEE Smart Mobility, Hoda is passionate about redefining the future of user experience through innovation and accessibility.`,
    organization: 'BraunAbility + GDG + Women Techmakers, I/O 2025',
    role: 'UX/UI Designer & Researcher',
    avatar: HodaSolati,
  },
  {
    id: 13,
    name: 'Ali El Sharif',
    twitter: '',
    linkedin: 'https://www.linkedin.com/in/ali-el-sharif-76530222b/',
    github: '',
    devfest: 'organizer',
    star: false,
    university: '',
    bio: `Ali El-Sharif works as a professor at St. Clair College in Windsor, where he teaches Data Analytics, Cybersecurity, and Cloud Computing. He also teaches at the University of Windsor and the University of Niagara Falls Canada.  Ali is a Google Developers Groups Windsor co-organizer and co-author of the upcoming book "Building Responsible AI with Python - Identify, explain, and mitigate bias with hands-on code examples." https://a.co/d/1O3Up6p`,
    organization: 'St. Clair College',
    role: 'Professor',
    avatar: AliElSharif,
  },
  {
    id: 14,
    name: 'Hernando Gonzalez Malabet',
    twitter: '',
    linkedin: 'https://www.linkedin.com/in/hernando-gonzalez-malabet-baa03625/',
    github: '',
    devfest: 'organizer',
    star: false,
    university: '',
    bio: `Hernando was born and raised in Barranquilla, Colombia. He holds a dual bachelor degree in Mechanical Engineering from the Universidad del Norte and University of South Florida, as well as a Ph.D. in Mechanical Engineering from the University of Alabama in Huntsville. He's currently working as a Battery Electro-Chemical Interactions Researcher at General Motors R&D, researching new technologies to increase battery safety for EVs. He's been part of SHPE since 2009 and has been an open advocate for hispanic development and  formation in advanced STEM careers`,
    organization:
      'Society of Hispanic Professional Engineers - SHPE Detroit Professional',
    role: 'Director of Professional Development',
    avatar: HernandoMalabet,
  },
  {
    id: 15,
    name: 'Nisa Solano',
    twitter: '',
    linkedin: 'https://www.linkedin.com/in/nisa-solano/',
    github: '',
    devfest: 'organizer',
    star: false,
    university: 'Wayne State University',
    bio: ``,
    organization: 'GDGC | AWS Cloud Club | SHPE Wayne State',
    role: 'Senior Computer Science Student',
    avatar: NisaSolano,
  },
  {
    id: 16,
    name: 'Raquel Estrada',
    twitter: '',
    linkedin: 'https://www.linkedin.com/in/raquel-estrada/',
    github: '',
    devfest: 'organizer',
    star: false,
    university: '',
    bio: `Raquel Estrada is the Vice President of Internal Relations for SHPE Detroit and a proud Salvadoran who is passionate about empowering the Hispanic community. She believes in the power of unity and collaboration to open doors for others in STEM. Raquel is a Process Transformation Manager – VP at Comerica Bank and holds three master’s degrees, along with a Bachelor’s in Industrial Engineering. With more than twelve years of international experience in financial services, consumer goods, and automotive, Raquel has built her career around driving change, leading with impact, and a deep passion for Continuous Improvement.`,
    organization:
      'Society of Hispanic Professional Engineers - SHPE Detroit Professional',
    role: 'SHPE Detroit Vice President',
    avatar: RaquelEstrada,
  },
  {
    id: 17,
    name: 'Maridy Mazaira',
    twitter: '',
    linkedin: 'https://www.linkedin.com/in/maridy-mazaira/',
    github: '',
    devfest: 'organizer',
    star: false,
    university: '',
    bio: `Maridy Mazaira graduated with Distinction from the University of Michigan–Dearborn with a B.S. in Industrial and Systems Engineering. She previously served as Supervisor of Engineering Continuous Improvement at DTE Energy, where she led initiatives in Tree Trimming, Damage Claims, Emergency Preparedness and Response and more.
Today, Maridy serves as President of the Society of Hispanic Professional Engineers – Detroit Chapter. Passionate about education and community impact, she is dedicated to creating opportunities, fostering representation, and inspiring the next generation of Hispanic students to pursue STEM careers.`,
    organization:
      'Society of Hispanic Professional Engineers - SHPE Detroit Professional',
    role: 'SHPE Detroit President',
    avatar: MaridyMazaira,
  },
  {
    id: 18,
    name: 'Jingran Wang',
    twitter: '',
    linkedin: 'https://www.linkedin.com/in/jingranwang/',
    github: '',
    devfest: 'organizer',
    star: false,
    university: 'University Of Michigan Dearborn',
    bio: `Experienced community organizer, including co-organizing GDG Ann Arbor. Android/Flutter Developer passionate about UX, readable, shippable code, accessibility, and teamwork.`,
    organization: 'Hikari Software',
    role: 'President',
    avatar: JingranWang,
  },
  {
    id: 19,
    name: 'Sohan Ketireddy',
    twitter: '',
    linkedin: 'https://www.linkedin.com/in/sohan-k',
    github: 'https://github.com/sohank1',
    devfest: 'devteam',
    star: false,
    university: 'University Of Michigan Dearborn',
    bio: ``,
    organization: '',
    role: 'Student',
    avatar: SohanKetireddy,
  },
  {
    id: 20,
    name: 'Kaylee Busenbark',
    twitter: '',
    linkedin: 'https://www.linkedin.com/in/kaylee-busenbark',
    github: 'https://github.com/kaybusenbark',
    devfest: 'devteam',
    star: false,
    university: 'University Of Michigan Dearborn',
    bio: ``,
    organization: '',
    role: 'Student',
    avatar: KayleeBusenbark,
  },
  {
    id: 21,
    name: 'Rehanashri',
    github: 'https://github.com/rehanashri',
    devfest: 'devteam',
    star: false,
    university: 'University Of Michigan Dearborn',
    organization: '',
    role: 'Student',
    avatar: Rehanashri,
  },
]
